import { useNavigate, useParams, useSearchParams } from '@ksyos/router';
import { useEffect } from 'react';
import { PatientDataError } from '../../../common/enums/PatientDataError';
import { ProcedureStatus } from '../../../common/enums/ProcedureStatus';
import { fetchJson } from '../../store/fetch';

export function CheckRequestStatus() {
    const [searchParams] = useSearchParams();
    const params = useParams();
    const navigate = useNavigate();
    const procedureId = searchParams.get('procedureId');

    async function getProcedureStatus() {
        try {
            const url = `/api/patient/procedure/${procedureId}/status`;
            const result = await fetchJson(url, 'GET');

            if (result.json.status === ProcedureStatus.active) {
                navigate(`/${params.service}/request`);
            } else {
                navigate(`/saml/login?error=${PatientDataError.procedureSent}`);
            }
        } catch {
            navigate(`/saml/login?error=${PatientDataError.invalidUrl}`);
        }
    }

    useEffect(() => {
        getProcedureStatus();
    }, []);

    return null;
}
